import { FormField } from '@zillow/constellation-10';

import { useMultiplexListingFlow } from '../../../../hooks/queries/multiplex';

import AddAmenitiesFormField from '../../../../components/WizardModularListing/AddAmenities/components/AddAmenitiesFormField';

import { WizardFormSectionContainer } from '../../../../styles/wizard';

import AmenitiesPropertyFormField from './AmenitiesPropertyFormField';

type Props = {
  isRelistingFieldset?: boolean;
};

const AmenitiesWithAdditionalAmenitiesFields = ({ isRelistingFieldset }: Props) => {
  const { isInMultiplexListingFlow } = useMultiplexListingFlow();

  return (
    <div data-testid="AmenitiesWithAdditionalAmenitiesFields">
      <WizardFormSectionContainer>
        <FormField>
          <AmenitiesPropertyFormField isRelistingFieldset={isRelistingFieldset} />
        </FormField>

        {!isInMultiplexListingFlow && (
          <FormField>
            <AddAmenitiesFormField isRelistingFieldset={isRelistingFieldset} />
          </FormField>
        )}
      </WizardFormSectionContainer>
    </div>
  );
};

export default AmenitiesWithAdditionalAmenitiesFields;
